import React from 'react';
import {Link} from '@mui/material';

const CustomLink = ({link, linkName}) => <Link color='#27adcd' href={link} target="_blank">{linkName}</Link>;

export default CustomLink;
